module.exports = __webpack_public_path__ + "img/sad-meme.098d4613.png";